var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.454,
    height: 35.956,
    viewBox: "0 0 30.454 35.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop-31",
    transform: "translate(-5.295 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_348",
    "data-name": "Caminho 348",
    d: "M19.39,19.779A8.39,8.39,0,1,0,11,11.39,8.4,8.4,0,0,0,19.39,19.779Zm0-14.382A5.993,5.993,0,1,1,13.4,11.39,6,6,0,0,1,19.39,5.4Z",
    transform: "translate(1.133 0)",
    fill: "#361f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_349",
    "data-name": "Caminho 349",
    d: "M35.626,30.738a15.586,15.586,0,0,0-30.208,0,4,4,0,0,0,.73,3.458,4.071,4.071,0,0,0,3.234,1.583H31.66A4.069,4.069,0,0,0,34.894,34.2a3.993,3.993,0,0,0,.73-3.458ZM33,32.724a1.69,1.69,0,0,1-1.342.658H9.383a1.692,1.692,0,0,1-1.342-.658,1.619,1.619,0,0,1-.3-1.4,13.189,13.189,0,0,1,25.56,0,1.612,1.612,0,0,1-.3,1.4Z",
    transform: "translate(0 3.176)",
    fill: "#361f6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.931d5b8a0342d318b6fe147bb90de04b.svg";
export { ForwardRef as ReactComponent };